import {siteKindsDimension} from '@packages/domains/site-access/abilities-dimension';
import {abilityFeature} from '../abilityFeature';

export const siteKinds = abilityFeature({
  key: 'siteKinds',
  isValid: function isSiteKindsValid(state, config) {
    return siteKindsDimension.isValid(state, config);
  },
});
